import { LANGUAGES } from "../constants"

export const getLocalizedField = (fieldName, langLabel) => {
  return langLabel === LANGUAGES.ENGLISH.label
    ? `${fieldName}`
    : `${fieldName}_de`
}
